export const BULLET_SYMBOL = '•';
export const ASTERISK_SYMBOL = '*';
export const RANGE_SYMBOL = '\u2011';

export const compareLatvian = (name: string, otherName: string): number =>
  name.localeCompare(otherName, 'lv');

export const capitalize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1);

const SENTENCE_START_LETTER = /(?:^|\.\s*)\p{Ll}$/u;

export const capitalizeSentenceStart = (typedText: string): string =>
  SENTENCE_START_LETTER.test(typedText)
    ? typedText.slice(0, -1) + typedText.slice(-1).toUpperCase()
    : typedText;

export const trimString = (value: string): string => value.trim();

export const isBlank = (value: string): boolean => value.trim().length === 0;

const decodeHtmlEntities = (value: string): string => {
  const element = document.createElement('textarea');
  element.innerHTML = value;

  return element.value;
};

export const stripHtml = (html: string): string =>
  decodeHtmlEntities(html.replace(/<[^>]*>/g, ' '))
    .replace(/\s+/g, ' ')
    .trim();

export const isNumeric = (value: string): boolean => /^\d+$/.test(value);

export const removeDiacritics = (value: string): string =>
  value.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const joinNonEmpty = (
  parts: Array<string | null | undefined | false>,
  separator = ', ',
): string => parts.filter(Boolean).join(separator);

export const getFullName = (person?: {
  firstName?: string;
  lastName?: string;
}): string =>
  person?.firstName && person?.lastName
    ? `${person.firstName} ${person.lastName}`
    : '';

export const getInitials = ({
  firstName,
  lastName,
}: {
  firstName: string;
  lastName: string;
}): string => `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();

export const getPercent = (part: number, total: number): number =>
  total > 0 ? Math.floor((part / total) * 100) : 0;

export const toPercentage = (value: number): string => `${value}%`;

export const withPercentSign = (value: string): string =>
  value.includes('%') ? value : `${value}%`;

export const parseDecimal = (value: string): number =>
  Number.parseFloat(value.replace(',', '.')) || 0;
